/*
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-07-24 21:13:51
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-11-25 13:25:30
 * @FilePath: \betdoce-web\src\utils\auth.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { store } from "@/store";
import { loginEvent, SHOW_LOGIN_EVENT } from "@/api/request";
import { recordClick } from "@/api/auth";

export const getCookie = (name: string): string | null => {
  const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[2]) : null;
};

export const setCookie = (name: string, value: string, days = 90) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
};

const getParam = (key: string): string | null => {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  } catch {
    return null;
  }
};

const ensureFbp = (time?: number): string => {
  const existing = getCookie("_fbp");
  if (existing) return existing;
  const ts = time ?? Date.now();
  const rand = Math.floor(Math.random() * 1e10);
  const v = `fb.1.${ts}.${rand}`;
  setCookie("_fbp", v);
  return v;
};

const getFbpTs = (): number | null => {
  const v = getCookie("_fbp");
  if (!v) return null;
  const parts = v.split(".");
  if (parts.length >= 3) {
    const n = Number(parts[2]);
    return Number.isNaN(n) ? null : n;
  }
  return null;
};

const ensureFbc = (time?: number): string | null => {
  const existing = getCookie("_fbc");
  let fbclid = sessionStorage.getItem("fbclid") || getParam("fbclid");
  if (!fbclid) {
    fbclid = getCookie("fbclid");
  } else {
    setCookie("fbclid", fbclid);
  }
  if (fbclid && !existing) {
    const ts = getFbpTs() ?? (time ?? Date.now());
    const v = `fb.1.${ts}.${fbclid}`;
    setCookie("_fbc", v);
    return v;
  }
  return existing;
};

export const rehydrateSessionFromCookie = (): void => {
  const keys = [
    "channel_id",
    "promote_url_id",
    "click_id",
    "fbclid",
    "link_id",
    "uuid",
  ];
  keys.forEach((k) => {
    const m = document.cookie.match(new RegExp("(^| )" + k + "=([^;]+)"));
    const v = m ? decodeURIComponent(m[2]) : null;
    if (v && !sessionStorage.getItem(k)) {
      sessionStorage.setItem(k, v);
    }
  });
};

const toHex = (buf: ArrayBuffer): string => {
  const arr = new Uint8Array(buf);
  let s = "";
  for (let i = 0; i < arr.length; i++) {
    s += arr[i].toString(16).padStart(2, "0");
  }
  return s;
};

const sha256Hex = async (input: string): Promise<string> => {
  const data = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return toHex(digest);
};

const getExternalIdCandidate = (): string | null => {
  try {
    const userInfo = getUserInfo();
    if (userInfo) {
      const uuid = userInfo?.user?.uuid;
      const id = userInfo?.user?.id;
      if (uuid) return String(uuid);
      if (id) return String(id);
    }
  } catch { }
  try {
    const fp = localStorage.getItem("Fingerprint");
    if (fp) {
      const v = JSON.parse(fp)?.visitorId;
      if (v) return String(v);
    }
  } catch { }
  return null;
};

// Token 相关操作
export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const setToken = (token: string): void => {
  localStorage.setItem("token", token);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem("refresh_token");
};

export const setRefreshToken = (refreshToken: string): void => {
  localStorage.setItem("refresh_token", refreshToken);
};

export const removeToken = (): void => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("isNew");
  localStorage.removeItem("isLogin");
  localStorage.removeItem("inviteCode");
  localStorage.removeItem("assistanceTimer");
  localStorage.removeItem("checkRebate");
  removeUserInfo();
};

export const removePddActivityData = (): void => {
  sessionStorage.removeItem("pddActivityData");
};

// 用户信息相关操作
export const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

export const setUserInfo = (userInfo: object) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

export const removeUserInfo = () => {
  localStorage.removeItem("userInfo");
};

// 登录状态检查
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

// 检查用户是否绑定了手机号
export const hasPhoneBound = (): boolean => {
  const userInfo = getUserInfo();
  return userInfo?.user?.account_name ? true : false;
};

const isMobileDevice = () => {
  return window.innerWidth <= 768;
};

// 存储目标路由
let targetRoute: string | null = null;

// 检查是否需要登录
export const checkAuth = (to: any, from: any) => {
  console.log("checkAuth", isAuthenticated(), to, from);
  if (!isAuthenticated() && to.meta?.requiresAuth) {
    console.log("checkAuth - user not authenticated");
    // 存储目标路由
    targetRoute = to.fullPath;
    const isMobile = isMobileDevice();
    console.log(isMobile);
    if (isMobile) {
      return "/user-info";
    } else {
      // 如果是从其他页面跳转过来的（即不是首次加载），取消导航，停留在当前页并弹出登录框
    if (from.name) {
      loginEvent.dispatchEvent(new Event(SHOW_LOGIN_EVENT));
      return false;
    }
    // 如果是首次加载（直接访问受保护链接），必须重定向到首页
      sessionStorage.setItem("authLogin", "true");
      return "/home";
    }
  }

  // 检查游客身份访问受限页面
  if (isAuthenticated()) {
    const userInfo = getUserInfo();
    console.log("userInfo for guest check:", userInfo);
    const isGuest = !userInfo?.user.phone; // 没有手机号的用户是游客

    // 定义需要绑定手机号的页面路径
    const restrictedPaths = [
      // "/records",
      // "/m/records",
      "/withdraw",
      "/m/withdraw",
      "/connection",
      "/m/connection",
      "/aposta",
      "/m/aposta",
      "/invite",
      "/cash-back",
      "/m/cash-back",
      "/m/invite",
      "/Atividades-Pinduoduo",
      "/m/Atividades-Pinduoduo",
      "/m/Opinion",
      "/Opinion",
    ];

    if (isGuest && restrictedPaths.includes(to.path)) {
      console.log("Guest user trying to access restricted path:", to.path);
      // 存储目标路由
      targetRoute = to.fullPath;
      // 触发手机号绑定提示事件
      const isMobile = isMobileDevice();
      if (isMobile) {
        window.dispatchEvent(new CustomEvent("show-join-us"));
      } else {
        window.dispatchEvent(
          new CustomEvent("show-phone-binding", {
            detail: { targetRoute: to.fullPath },
          })
        );
      }
      return false; // 阻止导航
    }
  }

  return true;
};

// 获取并清除目标路由
export const getAndClearTargetRoute = () => {
  const route = targetRoute;
  targetRoute = null;
  return route;
};

// 登出操作
export const logout = () => {
  removeToken();
  removeUserInfo();
  store.commit("auth/CLEAR_AUTH");
  window.location.href = "/home";
};

// 服务器记录事件（返回布尔值表示是否成功）
const record_click = async (hearPams: any, params: any): Promise<boolean> => {
  try {
    await recordClick(hearPams, params);
    return true;
  } catch (e) {
    return false;
  }
};

export const GoogleTag = async (
  event: string,
  params?: any
): Promise<boolean> => {
  // 初始化 params，确保不为 undefined
  if (!params) {
    params = {};
  }
  const userInfo = getUserInfo();
  console.log("GoogleTag",getUserInfo(), event, params);
  // 判断是否存在linkId
  if (!userInfo || !userInfo.user || !userInfo.user.pwa_channel_id) {
    return false;
  }

  // // 获取巴西时间 (UTC-3) 使用 moment.js
  // const getBrazilTime = () => {
  //   // 巴西时间是 UTC-3，使用 moment.js 处理时区
  //   return moment().utcOffset(-3).format('YYYY-MM-DD HH:mm:ss');
  // };

  // 添加事件发送时间到参数中
  params.event = event;
  params.event_id = sessionStorage.getItem("promote_url_id") || userInfo.user.pwa_channel_id;
  let time = Date.now()
  const fbp = ensureFbp(time);
  const fbc = ensureFbc(time);
  const _fbp = getCookie("_fbp");
  const fbclid = sessionStorage.getItem("fbclid") || getParam("fbclid") ||  getCookie("fbclid");
  params._fbp = _fbp;
  params.fbclid = fbclid;
  params.fbp = fbp;
  if (fbc) {
    params.fbc = fbc;
  }
  params.client_user_agent = navigator.userAgent || "";
  params.eventSourceUrl = window.location.href;
  params.event_source_url = window.location.href;
  const externalId = getExternalIdCandidate();
  if (externalId) {
    const normalized = String().trim().toLowerCase();
    try {
      params.external_id = await sha256Hex(normalized);
    } catch { }
  }
  if (sessionStorage.getItem("channel_id") === "9") {
    params.clickid = sessionStorage.getItem("click_id");
    // 使用项目约定的环境变量进行开发环境判断
    params.trackFlag = import.meta.env.VITE_APP_ENV === "development" ? true : params.trackFlag || false;
  }
  if(sessionStorage.getItem("channel_id") === "20"){
    params.clickid = sessionStorage.getItem("clickId") || "";
  }
  if (userInfo && userInfo.user) {
    if(userInfo.user.uuid){
      params.uuid = userInfo.user?.uuid || "";
    }
    if(userInfo.user.phone){
      params.phone = userInfo.user?.phone || "";
    }
  }
  // 全事件触发
  // const Eventlist = {
  //   100: "page_view", // 打开h5页面
  //   101: "visit",  // 快速登录
  //   102: "CompleteRegistration", // 首次游玩
  //   103: "purchase",  // 发起充值
  //   104: "charge_success",  // 充值成功
  //   105: "invite_reward", // 赠金领取
  //   106: "withdraw", // 用户提现
  //   107: "phone_bind", // 手机号绑定
  //   108: "first_purchase:Success", // 首充成功
  // };
  // 服务器记录 - 只记录到后端，不再发送前端埋点
  const ok = await record_click(
    {
      x_channel_link_id: sessionStorage.getItem("promote_url_id"),
      x_channel_event_code: event,
      x_channel_id: sessionStorage.getItem("channel_id") || "4",
    },
    params
  );
  return ok;
};
